module.exports = __webpack_public_path__ + "img/undraw_career_progress_ivdb.cca71bac.svg";